

export const VanEnv = document?.documentElement?.dataset?.vanEnv;